import React from 'react'

function Subscriptions() {
  return (
    <div>Subscriptions</div>
  )
}

export default Subscriptions